import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

/**
 * Styled container component for pause ad event information.
 * Positions event details (channel logo, titles, progress bar) in the pause ad modal.
 */
const PauseAdEventInfoContainer = styled.div`
  position: fixed;
  top: ${789 * Screen.widthRatio}px;
  left: ${86 * Screen.widthRatio}px;
  width: ${600 * Screen.widthRatio}px;
  height: ${88 * Screen.widthRatio}px;
  display: flex;
  flex-direction: row;
`;

export default PauseAdEventInfoContainer;
